import {css} from '@chakra-ui/styled-system';

export const scroller = css({
  // Firefox scrollbar
  [`*`]: {
    scrollbarWidth: `thin` /* or "auto" or "thin" */,
    scrollbarColor: `#babac0 transparent` /* thumb and track color */,
  },
  // Webkit scrollbar
  '*::-webkit-scrollbar': {
    backgroundColor: `background.secondary`,
    width: `16px`,
  },
  '*::-webkit-scrollbar-track': {
    backgroundColor: `transparent`,
    transition: `all 0.2s`,
  },
  '*::-webkit-scrollbar-track:hover': {
    backgroundColor: `blackAlpha.50`,
    borderRadius: `16px`,
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: `#babac0`,
    borderRadius: `16px`,
    border: `5px solid`,
    borderColor: `background.secondary`,
  },
  '*::-webkit-scrollbar-thumb:hover': {
    backgroundColor: `#a0a0a5`,
    border: `4px solid`,
    borderColor: `#fcfcfc`,
  },
  '*::-webkit-scrollbar-button': {
    display: `none`,
  },
});
